<template>
    <div>
        <v-toolbar flat color="white">
            <v-toolbar-title v-ripple style="cursor: pointer" @click="fetchData(onlyTrashed)">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <span v-on="on">Empresas {{onlyTrashed ? ' removidas' : ''}}</span>
                    </template>
                    <span>Clique para actualizar</span>
                </v-tooltip>
            </v-toolbar-title>
            <v-divider
                class="mx-2"
                inset
                vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-text-field class="mr-2 mb-2" fill-height
                  v-model="search"
                  append-icon="search"
                  label="procurar empresas..."
                  clearable
                  single-line
                  hide-details
            ></v-text-field>

            <!--Dialog for add and edit-->
            <v-btn v-if="!onlyTrashed" color="primary" icon @click="openModal"><v-icon>add</v-icon></v-btn>
            <!--<company-form-modal-->
                    <!--:company_types="company_types"-->
                    <!--:company_categories="company_categories"-->
                    <!--:active_states="active_states"-->
                    <!--:cities="cities"-->
            <!--&gt;</company-form-modal>-->
        </v-toolbar>


        <!--Data table-->
        <v-data-table xs12 sm6 md4
            :headers="headers"
            :items="companies"
            :loading="loading"
            class="elevation-1"
            :no-data-text="noDataText()"
            :rows-per-page-items="Global.ROWS_PER_PAGE"
            no-results-text="nenhum resultado"
            rows-per-page-text="por página"
            :pagination.sync="pagination"
            hide-actions
            disable-initial-sort
        >
            <v-progress-linear small v-slot:progress color="indigo" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props" >
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-center">{{ props.item.type_company_type != null ? props.item.type_company_type.name : ''}}</td>
                <td class="text-xs-center">{{ props.item.nif }}</td>
                <td class="text-xs-center">{{ props.item.city != null ? props.item.city.name : ''}}</td>
                <td class="text-xs-center"><v-chip small outline :color="props.item.active_state ? 'green' : 'red'">{{ props.item.active_state ? 'ativo' : 'inativo' }}</v-chip></td>
                <td class="text-xs-right">{{ props.item.created_at | formatDate}}</td>
                <td class="text-xs-right" style="min-width: 150px; padding-right: 10px;">
                    <v-icon v-if="!onlyTrashed" small class="mr-2" @click="showItem(props.item)">visibility</v-icon>
                    <v-icon v-if="!onlyTrashed" small class="mr-2" @click="editItem(props.item)">edit</v-icon>
                    <v-icon v-if="!onlyTrashed && props.item.id !== 1" small class="mr-2" @click="deleteItem(props.item)">block</v-icon>
                    <v-icon v-if="onlyTrashed" small class="mr-2" @click="restoreTrashedItem(props.item)">replay</v-icon>
                    <!--<v-icon v-if="onlyTrashed" small class="mr-2" @click="deleteTrashedItem(props.item)">delete</v-icon>-->
                    <v-menu offset-y left v-if="!onlyTrashed && isSuperAdminGroup">
                        <template v-slot:activator="{ on }">
                            <v-icon class="mr-2" v-ripple v-on="on">
                                arrow_drop_down
                            </v-icon>
                        </template>
                        <v-list>
                            <v-list-tile @click="openCompanyUsersList(props.item)">
                                <v-list-tile-title>Funcionários</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </td>
            </template>
            <template v-slot:footer>
                <td :colspan="headers.length">
                    <custom-pagination
                        :totalData="totalData"
                        @onPaginationChange="paginationChangeCallBack($event)"
                        :disabled="loading"
                    ></custom-pagination>
                </td>
            </template>
            <template v-if="error_fetching" slot="no-data">
                <v-btn flat color="primary" @click="fetchData(onlyTrashed)"><v-icon>refresh</v-icon></v-btn>
                <span class="text-xs-center">nenhum dado encontrado</span>
            </template>
        </v-data-table>

        <!--Confirmation Dialog-->
        <v-dialog persistent max-width="290" v-model="openConfirmationDialog" @close="openConfirmationDialog = false">
            <v-card>
                <!--<v-card-title class="headline">Use Google's location service?</v-card-title>-->
                <v-card-text class="text-xs-center">
                    <p v-if="confirmationModalOp === 1">Tens a certeza que queres eliminar <br> <b>{{selectedCompany.name}}</b>?</p>
                    <p v-if="confirmationModalOp === 2">Tens a certeza que queres <br> <span class="green--text text--darken-2">restaurar</span> <br><b>{{selectedCompany.name}}</b>?</p>
                    <p v-if="confirmationModalOp === 3">Tens a certeza que queres <br> <span class="red--text text--darken-2">eliminar permanentemente</span> <br><b>{{selectedCompany.name}}</b>?</p>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div v-if="!loading_modal">
                        <v-btn color="red darken-1" flat @click="confirmationDialogYes">Sim</v-btn>
                        <v-btn color="grey darken-1" flat @click="close">Não</v-btn>
                    </div>
                    <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--Button Removed articles-->
        <v-btn @click="fetchData(!onlyTrashed)" slot="activator" dark small :color="onlyTrashed ? 'red' : 'indigo'">
            {{onlyTrashed ? 'Sair de ' : ''}}Empresas removidas
        </v-btn>

        <company-users-form></company-users-form>

        <!--<div>-->
            <!--<button @click.prevent="openMyDialog()">my button</button>-->
        <!--</div>-->


    </div>
</template>

<script>
    import Vue from 'vue';
    import {mapGetters, mapActions} from 'vuex';
    import {eventBus} from "../../main";
    import {Global} from "../../config";
    import CompanyUsersForm from './CompanyUsersForm';
    import CustomPagination from '../extra/CustomPagination.vue';

    export default {
        name: 'company',

        created () {
            let vm = this;
            this.onCompanyAddOrEdited(vm);
            this.companies = [];

        },
        beforeDestroy(){
            eventBus.$off('onCompanyAdded');
            this.close();
        },

        data(){
            return {
                Global,
                pagination: {},
                totalData: 0,
                loading: false, //loading for list of companies in the datatable
                loading_modal: false, //loading for the action buttons in form modal
                error_fetching: false, //error for fetching list of companies in the datatable
                search: '', //search for the datatable
                openConfirmationDialog: false, //loads confirmation modal with yes or no
                headers: [
                    { text: 'Nome', align: 'left', value: 'name' },
                    { text: 'Tipo Empresa', align: 'center', value: 'company_type_name' },
                    { text: 'Nif', align: 'center', value: 'nif'},
                    { text: 'Cidade', align: 'center', value: 'city_name' },
                    { text: 'Estado', align: 'center', value: 'active_state' },
                    { text: 'Adicionado em', align: 'right', value: 'created_at' },
                    { text: 'Ações', align: 'right', value: '', sortable: false }
                ],

                companies: [],
                countries: [],
                selectedIndex: -1,
                // selectedCompany: null,
                onlyTrashed: false,
                confirmationModalOp: 0,
                newContactName: '',
            }
        },

        components: {
            // CompanyFormModal,
            CustomPagination,
            CompanyUsersForm,
        },

        watch: {
            pagination(){
                this.fetchData();
            },
            search() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.fetchData();
                }, 800);
            },
        },

        computed: {
            ...mapGetters([
                'getNewCompany'
            ]),

            showCompanyModal: {
                get(){
                    return this.$store.getters.getShowCompanyModal;
                },
                set(value){
                    this.$store.dispatch('setShowCompanyModal', value);
                }
            },
            selectedCompany: {
                get(){
                    return this.$store.getters.getSelectedCompany;
                },
                set(value){
                    this.$store.dispatch('setSelectedCompany', value);
                }
            },
            companyShow: {
                get(){
                    return this.$store.getters.getCompanyShow;
                },
                set(value){
                    this.$store.dispatch('setCompanyShow', value);
                }
            },
            cities: {
                get(){
                    return this.$store.getters.getGCities();
                },
                set(value){
                    this.$store.dispatch('setGCities', value);
                }
            },
            company_types: {
                get(){
                    return this.$store.getters.getGCompanyTypes;
                },
                set(value){
                    this.$store.dispatch('setGCompanyTypes', value);
                }
            },
            company_categories: {
                get(){
                    return this.$store.getters.getGCompanyCategories;
                },
                set(value){
                    this.$store.dispatch('setGCompanyCategories', value);
                }
            },
            showCompanyUsersModal: {
                get(){
                    return this.$store.getters.getShowCompanyUsersModal;
                },
                set(value){
                    this.$store.dispatch('setShowCompanyUsersModal', value);
                }
            },
        },

        methods: {

            paginationChangeCallBack(payload){
                this.pagination.rowsPerPage = payload.byPage;
                this.pagination.page = payload.currentPage;
                this.fetchData();
            },

            fetchData(onlyTrashed = false){
                if(this.loading) return;
                try{
                    this.onlyTrashed = onlyTrashed;
                    let url = onlyTrashed ? 'company/trashed' : 'company';

                    this.companies = [];
                    this.loading = true;
                    this.error_fetching = false;
                    Vue.axios.get(url, {
                        params: {
                            pag_size: this.pagination.rowsPerPage,
                            pag_current: this.pagination.page,
                            sort_field: this.getSortBy(this.pagination),
                            sort_order: this.getSortDes(this.pagination),
                            search: this.search,
                        }
                    })
                    .then(response => {
                        this.consoleLog(response);
                        if(!response.data.success){
                            this.loading = false;
                            this.error_fetching = true;
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }

                        if(onlyTrashed){
                            // this.setCompanies(response.data.response);
                            this.companies = response.data.response;
                        }else {
                            this.companies = response.data.response.companies;
                            this.company_types = response.data.response.companyTypes;
                            this.company_categories = response.data.response.companyCategories;
                            this.cities = response.data.response.cities;

                            this.totalData = response.data.response.total_data;

                        }

                        this.loading = false;
                    }).catch(error => {
                        this.consoleLog(error);
                        this.loading = false;
                        this.error_fetching = true;
                        this.showSnackBar('Erro ao carregar lista de empresas.!', 'error');
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao carregar lista de empresas!', 'error');
                    this.loading_modal = false;
                }
            },

            openCompanyUsersList(company){
                console.log('openning company users', company);
                this.showCompanyUsersModal = true;
                this.selectedCompany = company;
            },

            noDataText(){
                return this.loading ? 'a carregar empresas ...' : 
                        this.onlyTrashed ? 'Nenhuma empresa removida.' : 'nenhuma empresa.';
            },

            delete(){
                try{
                    this.loading_modal = true;
                    let name = this.selectedCompany.name;
                    Vue.axios.delete('company/'+this.selectedCompany.id)
                    .then(response => {
                        this.consoleLog(response);
                        if(!response.data.success){
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }
                        this.companies.splice(this.selectedIndex, 1);
                        this.showSnackBar(name+' removido com sucesso', 'success');
                    }).catch(error => {
                        this.consoleLog(error);
                        this.showSnackBar('Ocorreu um erro ao remover empresa', 'error');
                    }).finally( ()=> {
                        this.loading_modal = false;
                        this.openConfirmationDialog = false;
                        this.selectedCompany = this.getNewCompany;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao remover empresa!', 'error');
                    this.loading_modal = false;
                }
            },

            restoreTrashed(){
                try{
                    this.loading_modal = true;
                    let name = this.selectedCompany.name;
                    Vue.axios.put('company/trashed/restore/'+this.selectedCompany.id)
                    .then(response => {
                        if(!response.data.success){
                            this.handleErrorCodeMessage(response.data);
                            this.loading_modal = false;
                            return;
                        }
                        this.companies.splice(this.selectedIndex, 1);
                        this.showSnackBar(name+' restaurado com sucesso', 'success');
                    }).catch(error => {
                        // this.consoleLog(error);
                        this.showSnackBar('Erro ao restaurar empresa', 'error');
                    }).finally( ()=> {
                        this.loading_modal = false;
                        this.openConfirmationDialog = false;
                        this.selectedIndex = -1;
                        this.selectedCompany = this.getNewCompany;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao restaurar empresa!', 'error');
                    this.loading_modal = false;
                }
            },

            deleteTrashed(){
                try{
                    this.loading_modal = true;
                    let name = this.selectedCompany.name;
                    Vue.axios.delete('company/trashed/delete/'+this.selectedCompany.id)
                        .then(response => {
                            if(!response.data.success){
                                this.handleErrorCodeMessage(response.data);
                                this.loading_modal = false;
                                return;
                            }
                            this.companies.splice(this.selectedIndex, 1);
                            this.showSnackBar(name+ ' foi eliminado permanentemente com sucesso', 'success');
                        }).catch(error => {
                            this.showSnackBar('Erro ao eliminar permanentemente o empresa', 'error');
                            // this.consoleLog(error);
                        }).finally( ()=> {
                            this.loading_modal = false;
                            this.openConfirmationDialog = false;
                            this.selectedIndex = -1;
                            this.selectedCompany = this.getNewCompany;
                        });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao eliminar permanentemente a empresa!', 'error');
                    this.loading_modal =false;
                    // this.consoleLog(e);
                }
            },

            onCompanyAddOrEdited(vm){
                eventBus.$on('onCompanyAdded', function(company, editing){
                    vm.fetchData();
                })
            },

            getContactsJson(item){
                if(!item.contacts_json) return [];
                if(item.contacts_json instanceof Array)
                    return item.contacts_json;
                else
                    return JSON.parse(item.contacts_json);
            },

            showItem (item) {
                this.companyShow = true;
                this.selectedIndex = this.companies.indexOf(item);
                this.selectedCompany = item;
                this.selectedCompany.contacts_json = this.getContactsJson(item);
                this.showCompanyModal = true
            },

            editItem (item) {
                this.consoleLog(item);
                this.selectedIndex = this.companies.indexOf(item);
                this.selectedCompany = item;
                this.selectedCompany.contacts_json = this.getContactsJson(item);
                this.showCompanyModal = true
            },

            deleteItem (item) {
                this.confirmationModalOp = 1;
                this.selectedIndex = this.companies.indexOf(item);
                // this.$store.dispatch('setSelectedCompany', item);
                this.selectedCompany = item;
                this.selectedCompany.contacts_json = this.getContactsJson(item);
                this.openConfirmationDialog = true;
            },

            restoreTrashedItem (item){
                this.confirmationModalOp = 2;
                this.selectedIndex = this.companies.indexOf(item);
                this.selectedCompany = item;
                this.selectedCompany.contacts_json = this.getContactsJson(item);
                this.openConfirmationDialog = true;
            },

            deleteTrashedItem (item){
                this.confirmationModalOp = 3;
                this.selectedIndex = this.companies.indexOf(item);
                this.selectedCompany = item;
                this.selectedCompany.contacts_json = this.getContactsJson(item);
                this.openConfirmationDialog = true;
            },

            close () {
                this.showCompanyModal = false;
                this.openConfirmationDialog = false;
                this.loading = false;
                this.newContactName = '';
                this.companyShow = false;
                if(this.$v) this.$v.$reset();
                setTimeout(() => {
                    this.selectedCompany = this.getNewCompany;
                    this.selectedIndex = -1
                }, 300)
            },

            openModal(){
                this.selectedCompany = this.getNewCompany;
                this.showCompanyModal = true;
                eventBus.$emit('onCompanyModalOpen', true, false);
            },

            getNewEmptyContact(){
                return { phone: '', mobile_phone: '', email: '', fax: ''}
            },

            confirmationDialogYes(){
                if(this.confirmationModalOp === 1){
                    this.delete();
                }else if(this.confirmationModalOp === 2){
                    this.restoreTrashed();
                }else if(this.confirmationModalOp === 3){
                    this.deleteTrashed();
                }
            },

        },


    }
</script>

<style scoped>
    .mborder {
        border: 1px solid black;
    }
</style>